import { render, staticRenderFns } from "./SocialInsuranceNumber.vue?vue&type=template&id=464dae40&"
import script from "./SocialInsuranceNumber.vue?vue&type=script&lang=js&"
export * from "./SocialInsuranceNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports